import { render, staticRenderFns } from "./bar-api.md?vue&type=template&id=07084448&"
import script from "./bar-api.md?vue&type=script&lang=js&"
export * from "./bar-api.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07084448')) {
      api.createRecord('07084448', component.options)
    } else {
      api.reload('07084448', component.options)
    }
    module.hot.accept("./bar-api.md?vue&type=template&id=07084448&", function () {
      api.rerender('07084448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/api/bar-api.md"
export default component.exports